<template>
  <footer
    :class="{
      'pageFooter--autoMargin': autoMargin && !noMargin,
      'pageFooter--noMargin': noMargin
    }"
    class="pageFooter"
  >
    <a :href="legalNotice" target="_blank" rel="noopener noreferrer"
      >Legal Notice</a
    >
    <!-- <small
      >© Tadao Ando Architect & Associates, Niney et Marca Architectes, agence
      Pierre-Antoine Gatier</small
    > -->
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageFooter',
  props: {
    noMargin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      top: 0,
      autoMargin: false
    }
  },
  computed: {
    ...mapState({
      legalNotice: state => state.configuration.legalNotice
    })
  }
  // mounted() {
  //   window.addEventListener('resize', this.onResize, false)
  //   this.onResize()

  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.onResize, false)
  // },
  // methods: {
  //   onResize() {
  //     const rect = this.$el.getBoundingClientRect()
  //     this.autoMargin = rect.top < window.innerHeight - rect.height
  //   }
  // }
}
</script>

<style lang="scss">
.pageFooter {
  background-color: var(--white);
  color: var(--black);
  padding: 17px;
  margin-top: 4px;
  display: flex;
  flex-direction: column;

  .dark & {
    background-color: var(--black);
    color: var(--white);
  }

  @media screen and (min-width: 768px) {
    padding: 30px 30px;
    margin-top: 0;
    flex-direction: row;
  }

  &--autoMargin {
    margin-top: auto !important;
  }

  &--noMargin {
    margin-top: 0 !important;
  }

  a {
    display: block;
    font-size: 10px;
    line-height: 13px;
    text-decoration: unset;
    text-transform: uppercase;
  }

  small {
    font-size: 10px;
    line-height: 13px;
    margin-left: auto;
    text-transform: uppercase;
    margin-top: 10px;
    @media screen and (min-width: 768px) {
      margin-top: 0px;
    }
  }
}
</style>
